import React, { useState } from "react";
import { FiCopy } from "react-icons/fi";

export default function ChannelType({
  setCreateNewChannelSection,
  newChannel,
  setNewChannel,
  setSelectedChats,
}) {
  const [channelType, setChannelType] = useState("public");
  const [copied, setCopied] = useState(false);
  const publicUrl = `${process.env.REACT_APP_PUBLIC_FRONT_END_URL}/channels/${newChannel.slug}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(publicUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleDone = () => {
    setNewChannel((prev) => ({ ...prev, isPublic: channelType === "public" }));
    setCreateNewChannelSection(4);
    setSelectedChats([]);
  };

  return (
    <div className="max-w-md mx-auto px-2 mt-3">
      <h2 className="text-md font-semibold my-4 mt-1">Channel Type</h2>

      <div className="space-y-4 mb-6">
        <label
          className={`flex items-start gap-3 border min-h-20 max-h-20 rounded-xl p-4 cursor-pointer ${
            channelType === "public"
              ? "border-[var(--primary-color)] bg-purple-50"
              : "border-gray-300"
          }`}
        >
          <input
            type="radio"
            name="channelType"
            value="public"
            checked={channelType === "public"}
            onChange={() => setChannelType("public")}
            className="mt-1.5 bg-inherit accent-[var(--primary-color)]"
          />
          <div>
            <span className="font-medium text-sm text-gray-800">
              Public Channel
            </span>
            <p className="text-xs text-gray-500">
              Public Channel can be found in search, anyone can join them.
            </p>
          </div>
        </label>

        <label
          className={`flex items-start gap-3 border min-h-20 max-h-20 rounded-xl p-4 cursor-pointer ${
            channelType === "private"
              ? "border-[var(--primary-color)] bg-purple-50"
              : "border-gray-300"
          }`}
        >
          <input
            type="radio"
            name="channelType"
            value="private"
            checked={channelType === "private"}
            onChange={() => setChannelType("private")}
            className="mt-1.5 bg-inherit accent-[var(--primary-color)]"
          />
          <div>
            <span className="font-medium text-sm text-gray-800">
              Private Channel
            </span>
            <p className="text-xs text-gray-500">
              Private Channel can only be joined via invite link.
            </p>
          </div>
        </label>
      </div>

      {channelType === "public" && (
        <div className="mb-6">
          <label className="text-sm text-gray-500 font-normal block mb-2">
            Public Link
          </label>
          <div className="relative">
            <input
              type="text"
              value={publicUrl}
              readOnly
              className="w-full border rounded-lg px-3 py-3 text-sm text-gray-700 bg-white cursor-not-allowed pr-10"
            />
            <FiCopy
              size={18}
              className="absolute right-3 mt-2.5 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer hover:text-black"
              onClick={handleCopy}
            />
          </div>
          <p className="text-xs text-gray-400 mt-3">
            By enabling the public link, anyone can discover and join your channel.
          </p>
          {copied && (
            <p className="text-xs text-green-500 mt-1">Link copied to clipboard!</p>
          )}
        </div>
      )}

      <button
        onClick={handleDone}
        className="btn bg-[var(--primary-color)] text-white w-full h-12 font-normal rounded-full border-0"
      >
        Done
      </button>
    </div>
  );
}
